export const HPbodyContent = {
    en: {
        cards: [
            {title: "New to Quebec?", content: "Confused about the Quebec expressions while struggling to learn French at the same time?"},
            {title: "We understand!", content: "We've compiled the most commonly used Quebec expressions to help you understand and speak like a local!"},
            {title: "Follow our conversations", content: "They are filled with expressions that you won't be learning from school with vocabularies and examples explained in French and English."}
        ],
        startButton: "Let's try it out!",
        contactForm: {
            contactUs: "Contact Us",
            madeWith: "Made With",
            fromQC: "From Quebec",
            message: "Message",
            send: "Send",
            respondeMessage: {
                noMessage: "",
                general: 'Something went wrong, please try again later.💔',
                email: 'Please enter a valid email address.😉',
                success: 'Message sent successfully. Thanks for your support!🥳'
            }
        }
    },
    es: {
        cards: [
            {title: "Nuevo en Quebec?", content: "¿Confundido acerca de las expresiones quebequenses mientras lucha por aprender francés al mismo tiempo?"},
            {title: "¡Entendemos!", content: "¡Hemos recopilado las expresiones quebequenses más utilizadas para ayudarte a comprender y hablar como un local!"},
            {title: "Sigue las conversaciones", content: "Están llenos de expresiones que no aprenderás en la escuela con vocabularios y ejemplos explicados en francés e español."}
        ],
        startButton: "¡Probémoslo!",
        contactForm: {
            contactUs: "Contacto",
            madeWith: "Hecho Con",
            fromQC: "De Quebec",
            message: "Mensaje",
            send: "Enviar",
            respondeMessage: {
                noMessage: "",
                general: 'Algo salió mal, inténtalo de nuevo más tarde.💔',
                email: 'Por favor, introduce una dirección de correo electrónico válida.😉',
                success: 'Mensaje enviado con éxito. ¡Gracias por su apoyo!🥳'
            }
        }
    }
}